import { useContext, useEffect, useState } from "react";
import { ChatHeader, ChatBody } from "../chat";
import { SocketContext } from "../../contexts.js/SocketContext";

export default function UserChatWindow(props) {
  // user chat window with header and body 

  const { socket } = useContext(SocketContext);
  const [loadConvoFromDB, setLoadConvoFromDB] = useState(true);

  const {sessionId, chatHistory, initialChatHistory, getChatHistory} = props; 

  useEffect(() => {
    // on initial mount, check if there's an active conversation with this sessionId saved in the database
    if (loadConvoFromDB && socket && 
      sessionId &&
      chatHistory.length === initialChatHistory.length
    ) {
      // load conversation from database
      getChatHistory().then(() => setLoadConvoFromDB(false));
    }
  }, [loadConvoFromDB, socket, sessionId, chatHistory, initialChatHistory, getChatHistory]); 

  return (
    <div className="chat-wrapper">
      <ChatHeader text="Live Support Chat" 
      />
      <ChatBody
        submitChatMsg={props.submitChatMsg}
        chatHistory={props?.chatHistory}
        showRestartChat={props?.showRestartChat}
        handleStartNewChat={props?.handleStartNewChat}
        partnerIsTyping={props?.partnerIsTyping}
        handleTyping={props?.handleTyping}
        chatErrorMsg={props?.chatErrorMsg}
      />
    </div>
  );
}